module.exports = __webpack_public_path__ + "assets/images/logo_boerdereis_fr.1c7f00f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo_boerdereis_fr.png
// module id = 1658
// module chunks = 1